import React from 'react';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Partners from './Partners';
import Portfolio from './Portfolio';
import Contact from './Contact';

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Partners />
      <Portfolio />
      <Contact />
    </>
  );
}

export default Home;
